import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
    InputGroup, InputGroupAddon, InputGroupText, Input, Row,
    Col, FormGroup, Button, Form
} from 'reactstrap';
import { ResetPass } from '../../../../redux/Action/fogoetpassword';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import validate from './validation';

const renderField = ({ input, placeholder, type, icone, meta: { touched, error, warning } }) => (
    <div>

        <InputGroup>
            <Input {...input} placeholder={placeholder} type={type} />
            <InputGroupAddon addonType="prepend">
                <InputGroupText>
                    <i className={icone}></i>
                </InputGroupText>
            </InputGroupAddon>
        </InputGroup >

        <div>
            {touched && ((error && <span className="erroMSG"> {error}</span>))}
        </div>
    </div>
)

class ResetPassword extends Component {

    onSubmit = (values) => {
        let re_password = {
            email: localStorage.getItem('email'),
            newPassword: values.newPassword,
            type:this.props.type
        }
        console.log("reset password",re_password)
        this.props.ResetPass(re_password);
    }

    render() {
        const { handleSubmit, submitting } = this.props;

        return (
            <div>
               
                <Row>
                    <Col lg="12">
                        <h1 className="mb-3">كلمة المرور</h1>
                    </Col>
                    <Col lg="10" className="m-auto">
                        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <FormGroup>
                                <Field type="password" name="newPassword" component={renderField} placeholder="كلمة المرور" icone="fa fa-lock" />
                            </FormGroup>
                            <FormGroup>
                                <Field type="password" name="confirmpassword" component={renderField} placeholder="تاكيد كلمة المرور" icone="fa fa-lock" />
                            </FormGroup>
                            <div className="pb-4 pt-2">
                                <Button disabled={submitting}>تاكيد</Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        ResetPass,
        
    }
    , dispatch
)

export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(ResetPassword));